import { Button, Column, Dialog, DialogActions, DialogContent, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

/** Matches its sibling `ReferralNotEligibleDialog`, which it replaces for a re-tap. */
const PANEL_STYLE = { maxWidth: 358 } as const;

/** Points `aria-labelledby` at the heading, as `ReferralNotEligibleDialog` does. */
const TITLE_ID = 'referral-already-recorded-title';

export interface IReferralAlreadyRecordedDialogProps {
  /** Whether the dialog is visible. */
  open: boolean;
  /** "Close", the backdrop and Escape. */
  onClose: () => void;
}

/**
 * GOTU-9922: a signed-in office opened the v2 referral link it signed up with.
 * The referral is recorded, so Not Eligible would read as a failure; this says
 * so. Copy from design (Jenny G), identical to mobile's dialog.
 *
 * Presentational only; `Dashboard` renders it off the navigation state
 * `ReferralLinkRedirect` sets.
 */
export const ReferralAlreadyRecordedDialog = ({
  open,
  onClose,
}: IReferralAlreadyRecordedDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    size="medium"
    style={PANEL_STYLE}
    aria-labelledby={TITLE_ID}
    data-testid="referral-already-recorded-dialog"
  >
    <DialogContent>
      <Column gap={4} align="center" pt={6}>
        <Typography id={TITLE_ID} bold variant="subtitle1" textAlign="center">
          Referral already recorded
        </Typography>
        <Typography variant="body1" textAlign="center" color={colors.neutral[500]}>
          You&rsquo;ve already linked this referral code to your account. No action is needed.
        </Typography>
      </Column>
    </DialogContent>
    <DialogActions className="justify-center">
      <Button
        data-cy="referral-already-recorded-close-button"
        data-testid="referral-already-recorded-close-button"
        onClick={onClose}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
);
